.option {
	display: flex;
	justify-content: space-between;
}
